import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
export function ArchiveAttachments({ entryId, eventId }: { entryId?: string; eventId?: string }) {
  const q = useQuery({
    queryKey: ['archive-media', entryId, eventId],
    queryFn: async () =>
      entryId
        ? (
            await api.get<{ attachments: { id: string; url: string; type: string }[] }>(
              `/archive-entries/${entryId}/attachments`,
            )
          ).attachments
        : (
            await api.get<{ data: { id: string; url: string; type: string }[] }>(
              `/media?eventId=${eventId}`,
            )
          ).data.filter((a) => a.type !== 'photo'),
    enabled: !!entryId || !!eventId,
  });
  return (
    <div className="flex flex-wrap gap-3">
      {q.data?.map((a) => (
        <a key={a.id} href={a.url} target="_blank" rel="noreferrer">
          <img className="h-32 rounded object-contain" src={a.url} alt={`${a.type} scan`} />
          <span>{a.type}</span>
        </a>
      ))}
      {q.error && <p>{q.error.message}</p>}
    </div>
  );
}
